module.exports = __webpack_public_path__ + "media/student_contributors/09StellaSantaAna-188c6058.png";